import React from 'react';
import styled from 'styled-components';

const JobCard = styled.div`
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 1rem;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const JobTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

const JobInfo = styled.p`
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
`;

const RemainingTime = styled.p`
  font-size: 0.875rem;
  font-weight: 500;
  color: #f97316;
`;

const ScheduledJobCard = ({ job, calculateRemainingTime, isNodeSchedule }) => {
  // expiration_time 또는 nextInvocation 사용
  const expirationTime = isNodeSchedule
    ? job.nextInvocation
    : job.expiration_time || job.ore__expiration_time;

  return (
    <JobCard>
      <JobTitle>주문 ID: {job.menu_id}</JobTitle>
      <JobInfo>상태: {job.agent_status}</JobInfo>
      <JobInfo>
        만료 시간:{' '}
        {expirationTime
          ? new Date(expirationTime).toLocaleString('ko-KR', {
              timeZone: 'Asia/Seoul',
            })
          : '없음'}
      </JobInfo>
      <JobInfo>대행자: {job.assigned_agent_name || '미할당'}</JobInfo>
      {/* 노드 스케줄된 작업에는 아래 정보가 없을 수 있으므로 조건부로 표시 */}
      {!isNodeSchedule && (
        <>
          <JobInfo>영화 제목: {job.movie_title}</JobInfo>
          <JobInfo>상영관: {job.theater}</JobInfo>
          <JobInfo>상영 날짜: {job.date}</JobInfo>
          <JobInfo>상영 시간: {job.screening_time}</JobInfo>
          <JobInfo>관람 인원: {job.viewer_count}</JobInfo>
        </>
      )}
      <RemainingTime>
        {expirationTime
          ? calculateRemainingTime(expirationTime)
          : '예약되지 않음'}
      </RemainingTime>
    </JobCard>
  );
};

export default ScheduledJobCard;
